import { makePercent } from "../../../../../utils/factorys"
import { PetalProps } from "../../interfaces"
import { StalkContainer } from "./styles"

export const Stalk: React.FC<PetalProps> = ({ heigth, sigla, father }) => {
  return (
    <StalkContainer heigth={makePercent(heigth,father)} >
      <div className='text'>
        <p>{sigla}</p>
      </div>
    </StalkContainer>
  )
}